import { Options, Vue } from 'vue-class-component'
import LeftSideBar from '../LeftSideBar/index.vue'

@Options({
  components: {
    LeftSideBar
  }
})
export default class BestyrelsenView extends Vue {}
